import React, { FC, useCallback, useMemo } from 'react';
import LanguageIcon from '../../../assets/icons/inline/translation.inline.svg';
import * as classes from './LanguageSwitcher.module.scss';
import { Language } from '../../../enums/Language';
import Select from '../Select/Select';
import { languageInfo } from '../../../dictionary/languageInfo';
import { SelectOption } from '../../../interfaces/SelectOption';
import { useI18next } from 'gatsby-plugin-react-i18next';
import cn from 'classnames';

interface Props {
  isWhite?: boolean;
}

const LanguageSwitcher: FC<Props> = ({ isWhite }) => {
  const { languages, changeLanguage, language } = useI18next();

  const onChangeHandler = useCallback(
    async (val: SelectOption) => {
      await changeLanguage(val.value as Language);
    },
    [changeLanguage],
  );

  const languagesList: Array<SelectOption> = useMemo(() => {
    return languages.map(lang => {
      const langInfo = languageInfo.get(lang as Language);
      return { value: lang, label: langInfo?.fullName, additionalLabel: langInfo?.shortName } as SelectOption;
    });
  }, [languages]);

  const currentLanguage = useMemo(() => {
    return languagesList.find(item => item.value === language);
  }, [language, languagesList]);

  return (
    <div className={classes.wrapper}>
      <div className={cn(classes.langIcon, isWhite && classes.isWhite)}>
        <LanguageIcon />
      </div>
      <Select
        listClassName={classes.selectList}
        inputClassName={classes.selectValue}
        optionClassName={classes.selectItem}
        dropDownIconClassName={cn(isWhite && classes.whiteDropDown)}
        options={languagesList}
        value={currentLanguage}
        onChangeAction={onChangeHandler}
      />
    </div>
  );
};

export default LanguageSwitcher;
